import { Container, Grid, Box } from '@mui/material';
import React from 'react';
import Ourcover from '../../Component/OurCover/OurCover.module.scss';

function OurCover(props) {
    return (
        <section id={Ourcover.ourcover}>
            <Box className={Ourcover.ourcover}>
                <Container maxWidth='lg' sx={{ height: '100%' }}>
                    <Grid container sx={{ alignItems: 'center', height: '100%' }}>
                        <Grid item xs={12} sx={{ height: '100%' }}>
                            <Box className={Ourcover.cover}>
                                <h1>{props.ourHead}</h1>
                                <p>{props.title}</p>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </section >
    )
}

export default OurCover;
